import axios, { AxiosError } from 'axios';
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

import store from '@/store';
import { ILoginUser } from '@/types';

@Module({
  dynamic: true,
  name: 'loginUser',
  store,
})
export class LoginUser extends VuexModule {
  public loginUser: ILoginUser | null = null;

  @Mutation
  public updateLoginUser(loginUser: ILoginUser | null): void {
    this.loginUser = loginUser;
    console.log(this.loginUser);
  }

  @Action({ commit: 'updateLoginUser' })
  public async getLoginUser() {
    const res = await axios
      .get('/api/login_user/')
      .catch((error: AxiosError) => {
        console.error(error);
        return null;
      });
    return res?.data ?? null;
  }
}

export default getModule(LoginUser);
